import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';

export default {
  attributeName: 'appDictionaryItems',
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: true,
  canRemove: true,
  editURL: routes.APP_PROVIDER_EDIT,
  emptyMessage: "You don't have dictionary items, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'key',
      label: 'Key',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The name of the dictionary item. It must be without spaces and special characters. It must be unique per app.',
      default: '',
      canEdit: true,
      canCreate: true,
      canFilter: true,
      canOrder: true,
      exactWidth:'300px'

    },
    {
      attributeName: 'type',
      label: 'Type',
      type: FormInputTypes.SELECT,
      default: [1],
      width: '12rem',
      options: [
        { name: 'String', value: FormInputTypes.TEXT_INPUT.TEXT },
        { name: 'File', value: FormInputTypes.DOWNLOADABLE },
      ],
      canOrder: true,
      canEdit: false,
      canFilter: true,
      canCreate: true,
      helpText: 'Type of dictionary element, you have two options: string or file.',
      exactWidth:'180px'
    },
    {
      attributeName: 'description',
      label: 'Description',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: true,
      canCreate: true,
      default: '',
      helpText: 'The text to help the user to set the value of the key.',
      canFilter: true,
      canOrder: true,
    },
  ],
};
